function BaseUrl() {
  return import.meta.env.VITE_BASE_URL;
  // return "https://showroom-backend.ai.dkcexportstna.in";
}

export default BaseUrl;
